export default function (v: number | null): string {
  if (!v) return "";

  const hours = Math.floor(v);
  const minutes = (v - hours) * 60;
  return `${hours}:${String(minutes).padStart(2, "0")}`;
}
